var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52pt",
    height: "52pt",
    viewBox: "0 0 752 752",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m527.29 474.66c3.6328 0 6.5781 2.9453 6.5781 6.5781v26.309c0 3.6328-2.9453 6.5781-6.5781 6.5781h-302.57c-3.6328 0-6.5781-2.9453-6.5781-6.5781v-26.309c0-3.6328 2.9453-6.5781 6.5781-6.5781zm0-118.39c3.6328 0 6.5781 2.9453 6.5781 6.5781v26.309c0 3.6328-2.9453 6.5781-6.5781 6.5781h-302.57c-3.6328 0-6.5781-2.9453-6.5781-6.5781v-26.309c0-3.6328 2.9453-6.5781 6.5781-6.5781zm0-118.39c3.6328 0 6.5781 2.9453 6.5781 6.5742v26.312c0 3.6328-2.9453 6.5781-6.5781 6.5781h-302.57c-3.6328 0-6.5781-2.9453-6.5781-6.5781v-26.312c0-3.6289 2.9453-6.5742 6.5781-6.5742z",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.fe0749d27d79a8fdeefad07d1eb9599f.svg";
export { ForwardRef as ReactComponent };